import { render, staticRenderFns } from "./AnalisiRecord.vue?vue&type=template&id=60555502"
import script from "./AnalisiRecord.vue?vue&type=script&lang=js"
export * from "./AnalisiRecord.vue?vue&type=script&lang=js"
import style0 from "./AnalisiRecord.vue?vue&type=style&index=0&id=60555502&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports